import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { tryToFetchSingleInvoice } from '../../../../store/brokers/suppliers/invoices/InvoicesSlice';
import Modal from '../../../../shared/modal';
import Table from '../../../../shared/table';
import Button from '../../../../shared/button';


interface IInvoiceDetailsModal {
    openModal: boolean;
    invoiceId: string;
    handleCloseModal: () => void;
}

const InvoiceDetailsModal = ({
    openModal,
    invoiceId,
    handleCloseModal,
}: IInvoiceDetailsModal) => {
    const dispatch = useAppDispatch();
    const [invoiceDetails, setInvoiceDetails] = useState<any>();
    const state = useAppSelector((state) => state?.invoices);

    useEffect(() => {
        setInvoiceDetails(state?.invoiceDetails)
    }, [state?.invoiceDetails])

    useEffect(() => {
        if (invoiceId) {
            dispatch(tryToFetchSingleInvoice(invoiceId || ''))
        } else {
            setInvoiceDetails(undefined)
        }
    }, [invoiceId, openModal])

    const onCloseModal = () => {
        handleCloseModal();
    }

    let findTotalQuantity = 0;

    invoiceDetails?.purchaseInfo?.items && invoiceDetails?.purchaseInfo?.items?.length > 0 &&
        [...invoiceDetails?.purchaseInfo?.items].map((currentValue: any) => {
            findTotalQuantity = Number(findTotalQuantity) + Number(currentValue?.qty || 0);
            return currentValue;
        });

    const totalShippingCosts = invoiceDetails?.invoiceInfo && invoiceDetails?.invoiceInfo?.shippingCosts + invoiceDetails.invoiceInfo?.shippingTaxAmount
    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Invoice Details'
            contentContainerStyle='!min-w-[70vw]'>
            <div className={'p-2 min-w-[65vw] min-h-[300px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Details</p>
                </div>
                <div className='bg-[#f8f9fc] rounded-[6px] p-3'>
                    <p className='text-[20px]'>Review Details</p>
                    <div className='grid grid-cols-4 span-2 my-3 border-b border-[#e4e4e4] pb-2'>
                        {invoiceDetails?.supplierInfo &&
                            <div className='mb-2'>
                                <span>Supplier: </span>
                                <span className='font-bold'>{invoiceDetails?.supplierInfo?.name}</span>
                            </div>
                        }
                        {invoiceDetails?.partner &&
                            <div className='mb-2'>
                                <span>Order Created: </span>
                                <span className='font-bold'>{invoiceDetails?.partner?.companyName}</span>
                            </div>
                        }
                        {invoiceDetails?.status &&
                            <div className='mb-2'>
                                <span>Status: </span>
                                <span className='font-bold'>{invoiceDetails?.status === 'approved' ? 'Approved' : 'Invoice Sent'}</span>
                            </div>
                        }
                        {invoiceDetails?.expectedDeliveryDate &&
                            <div className='mb-2'>
                                <span>Delivery Date: </span>
                                <span className='font-bold'>{moment(invoiceDetails?.expectedDeliveryDate).format('DD MMMM YYYY')}</span>
                            </div>
                        }
                        {invoiceDetails?.invoiceNumber &&
                            <div className='mb-2'>
                                <span>Invoice Number: </span>
                                <span className='font-bold'>{invoiceDetails?.invoiceNumber}</span>
                            </div>
                        }
                    </div>
                    <div className=' border-b border-[#e4e4e4] pb-2 my-2'>
                        <Table
                            columns={['Item', 'Price per Unit', 'Units', 'Subtotal']}
                            hidePagination={true}
                            headStyle='!bg-[#000000] !text-white'>
                            {invoiceDetails?.purchaseInfo?.items && invoiceDetails?.purchaseInfo?.items?.length > 0 && invoiceDetails?.purchaseInfo?.items?.map((row: any, idx: number) => {
                                return (
                                    <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                        <td className='px-6 py-4'>{row?.itemName}</td>
                                        <td className='px-6 py-4'>{Number(row?.price || 0).toFixed(2)}</td>
                                        <td className='px-6 py-4'>{row?.qty || ''} unit(s)</td>
                                        <td className='px-6 py-4'>
                                            {(Number(row?.price || 0) * Number(row?.qty || 0)).toFixed(2)}
                                        </td>
                                    </tr>
                                )
                            })}
                            {invoiceDetails?.purchaseInfo?.items && invoiceDetails?.purchaseInfo?.items?.length > 0 &&
                                <tr className='!font-bold !text-black !border-t-2 border-[#f7a21e]'>
                                    <td></td>
                                    <td className='px-6 py-4'>Total:</td>
                                    <td className='px-6 py-4'>{findTotalQuantity} unit(s)</td>
                                    <td className='px-6 py-4'>
                                        {Number(invoiceDetails?.invoiceInfo?.totalAmount || 0).toFixed(2)}
                                    </td>
                                </tr>
                            }
                        </Table>
                        <div className='mt-2 grid grid-cols-2 span-2 min-w-[100%]'>
                            <div >
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Total Items</p>
                                    <p className='text-[20px] text-primary-default'>{findTotalQuantity} Units</p>
                                </div>
                                {invoiceDetails?.invoiceInfo &&

                                    <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                        <p className='text-[20px]'>Shipping Costs (Tax Included)</p>
                                        <p className='text-[20px] text-primary-default'>
                                            {Number(totalShippingCosts || 0).toFixed(2)}
                                        </p>
                                    </div>
                                }
                                <div className='border border-[#a4a4a4] flex flex-row justify-between items-center p-2'>
                                    <p className='text-[20px]'>Total Amount</p>
                                    <p className='text-[20px] text-primary-default'>
                                        {Number(invoiceDetails?.invoiceInfo?.total || 0).toFixed(2)}
                                    </p>
                                </div>
                            </div>
                            <div className='flex flex-row justify-center items-center self-center'>
                                <Button
                                    label={'Close'}
                                    className='btn-primary min-w-[150px] mr-3 !rounded'
                                    onClickButton={() => onCloseModal()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}
export default InvoiceDetailsModal;